// extracted by mini-css-extract-plugin
export default {"wrap":"yw-z","fullWidth":"zw-z","items":"Aw-z","featureCss":"Bw-z","disabled":"Cw-z","imgCss":"Dw-z"};